var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-headerWrapper"},[_c('div',{staticClass:"cf-headerContainer"},[_c('span',{staticClass:"cf-headerTitle"},[_vm._v("Engagement Calculators")]),_c('div',{staticClass:"cf-entityNames"},[_vm._v(" "+_vm._s(_vm.clientName)+" "+_vm._s(_vm.partnerName == "" ? "" : "and " + _vm.partnerName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }